module.exports = __webpack_public_path__ + "static/img/java1.dea3251c.png";